import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client/dist/sockjs';

class WebSocketManager {
  constructor() {
    this.connections = new Map();
  }

  getProjectConnection(projectId) {
    if (!this.connections.has(projectId)) {
      const sock = new SockJS('/ws/factive');
      const stompClient = new Client({
        webSocketFactory: () => sock,
        reconnectDelay: 5000,
        connectHeaders: {
          'project-id': projectId,
        },
      });

      this.connections.set(projectId, stompClient);

      if (!stompClient.active) {
        stompClient.activate();
      }
    }
    return this.connections.get(projectId);
  }

  getConsumerProjectConnection({ projectName, projectPassword }) {
    if (!this.connections.has(projectPassword)) {
      const sock = new SockJS('/ws/factive');
      const stompClient = new Client({
        webSocketFactory: () => sock,
        reconnectDelay: 5000,
        connectHeaders: {
          'project-name': projectName,
          'project-password': projectPassword,
        },
      });

      this.connections.set(projectPassword, stompClient);

      if (!stompClient.active) {
        stompClient.activate();
      }
    }
    return this.connections.get(projectPassword);
  }

  closeProjectConnection(projectId) {
    const stompClient = this.connections.get(projectId);
    if (stompClient) {
      if (stompClient.active) {
        stompClient.deactivate();
      }
      this.connections.delete(projectId);
    }
  }

  closeConsumerProjectConnection(projectPassword) {
    const stompClient = this.connections.get(projectPassword);
    if (stompClient) {
      if (stompClient.active) {
        stompClient.deactivate();
      }
      this.connections.delete(projectPassword);
    }
  }
}

const webSocketManager = new WebSocketManager();
export default webSocketManager;
